export default __webpack_public_path__ + "static/media/ic_cup_small.f4c734c2.svg";